(() => {
  const SELECTOR = '[data-jax-reveal]';

  function revealImmediately(element) {
    element.classList.add('is-revealed');
  }

  function initialiseReveals(root = document) {
    const elements = root.querySelectorAll(SELECTOR);

    if (!elements.length) return;

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(revealImmediately);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px -4% 0px'
      }
    );

    elements.forEach((element) => {
      if (element.dataset.jaxRevealInitialised === 'true') return;

      element.dataset.jaxRevealInitialised = 'true';
      observer.observe(element);
    });
  }

  function init() {
    const iconSection = document.querySelector(
  '#shopify-section-template--19953278156877__section_B43Uir'
);

if (iconSection) {
  const iconItems = iconSection.querySelectorAll(
    '.section-content-wrapper > .group-block'
  );

  iconItems.forEach((item) => {
  item.dataset.jaxReveal = 'up';
  item.style.setProperty('--jax-reveal-delay', '0ms');
});
}
const contactSection = document.querySelector(
  '#shopify-section-template--19953278156877__section_fNt4zQ'
);

if (contactSection) {
  const leftContent = contactSection.querySelectorAll(
    '.section-content-wrapper > .text-block, .section-content-wrapper > rte-formatter'
  );

  const form = contactSection.querySelector('.contact-form');

  leftContent.forEach((item) => {
    item.dataset.jaxReveal = 'up';
  });

  if (form) {
    form.dataset.jaxReveal = 'up';
    form.style.setProperty('--jax-reveal-delay', '120ms');
  }
}
    initialiseReveals();

    document.addEventListener('shopify:section:load', (event) => {
      initialiseReveals(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();